import { useGetStudentsSchedulingDetails, type StudentSchedulingDetails } from '@/features/scheduling/api/getStudentsSchedulingDetails';
import type { SystemBanner } from '../api/getSystemBanner';
import { useActiveSystemBanners } from './useActiveSystemBanners';

const getGuardianCenterIds = (students: StudentSchedulingDetails[]) =>
  students.flatMap((student) => [student.inCenterCenterSettings?.center_id, student.onlineCenterSettings?.center_id]).filter((id) => id !== undefined);

// Set from the runtime banner file during maintenance windows (see README > "Showing a maintenance banner").
export const useIsSchedulingBlocked = () => {
  const blockingBanners = useActiveSystemBanners().filter((banner) => banner.blockScheduling);
  const needsCenters = blockingBanners.some((banner) => banner.exemptCenterIds.length > 0);

  // Only fetched while an exemption could apply; until it loads, guardians stay blocked.
  const { data } = useGetStudentsSchedulingDetails({ options: { enabled: needsCenters } });
  const centerIds = getGuardianCenterIds(data?.students ?? []);

  const isExempt = (banner: SystemBanner) => banner.exemptCenterIds.some((id) => centerIds.includes(id));

  return blockingBanners.some((banner) => !isExempt(banner));
};
